// @flow

import { HostingTypeToQueryParam } from '@atlassian/mpac-types';

import type { HostingQueryParamType } from '@atlassian/mpac-types';

export const AllHostingTypeQueryParams: HostingQueryParamType[] = Object.keys(
  HostingTypeToQueryParam
).map(key => HostingTypeToQueryParam[key]);

export const showOnlyPublicQueryParam = 'showOnlyPublic';

export const STARGATE_BASE_PATH = '/gateway/api';

export const PAGE_CONTAINER_MAX_WIDTH = '990px';
